export default __webpack_public_path__ + "static/media/image_6.a3ba83a8.png";